import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.bar.rank;

export const barRankSelector = createSelector(
    [selectRank],
    (data ) => data
)
